@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@modalFontSize: small;

.row {
  margin: 10px;
  font-size: @modalFontSize;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;

  &.row-with-error {
    align-items: flex-start;
  }

  .label {
    font-size: @modalFontSize;
    width: calc(25% ~'-' 10px);
    margin-right: 10px;
    text-align: right;
    display: inline-block;

    &.label-with-error {
      margin-top: 10px;
    }
  }

  .value {
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .readonly {
    color: @carrier-pickup--modal-read-only--text-color;
  }

  .vertical-list.value {
    align-items: flex-start;
  }

  .vertical-list.label {
    align-items: flex-end;
  }

  .vertical-list {
    display: flex;
    flex-flow: column;

    div {
      padding-top: 3px;
      padding-bottom: 3px;
      display: block;
      width: 100%;
    }
  }
}
